"use client";

import { createContext, useContext } from "react";
import type { CatalogCartAddress, CatalogCartLine } from "@/lib/catalogCart";

// Context keranjang katalog — SENGAJA dipisah dari `CatalogCartProvider.tsx`.
//
// `ProductDetail` dipakai bersama oleh `/product/[slug]` (toko utama) dan
// `/toko/[kode]/product/[slug]`, jadi ia harus bisa memanggil `useCatalogCart()`
// di kedua tempat. Kalau hook itu tinggal di berkas provider, mengimpornya
// menyeret RANTAI PENUH komponennya — lembar keranjang, `BottomSheet`, dan
// `DistrictPicker` (26 KB) — ke dalam bundel halaman produk toko utama yang tak
// punya keranjang katalog sama sekali.
//
// Berkas ini karena itu tak mengimpor satu komponen pun: hanya context, hook,
// dan tipe.

export type CatalogCartApi = {
  kode: string;
  resellerName: string;
  waNumber: string;
  lines: CatalogCartLine[];
  address: CatalogCartAddress | null;
  totalQty: number;
  /** `false` = keranjang tersimpan belum selesai dibaca dari localStorage. */
  isReady: boolean;
  /** `false` = ditolak karena keranjang penuh. */
  add: (line: CatalogCartLine) => boolean;
  setQty: (key: string, qty: number) => void;
  remove: (key: string) => void;
  clearLines: () => void;
  setAddress: (address: CatalogCartAddress | null) => void;
  openSheet: () => void;
  closeSheet: () => void;
  /**
   * Catat satu Order WA untuk statistik "Website Toko Saya" (mig 6210) —
   * dipanggil tepat saat "Pesan via WhatsApp" ditekan. Best-effort: tak pernah
   * melempar, tak pernah menahan WhatsApp terbuka.
   */
  trackOrder: (lines: CatalogCartLine[]) => void;
};

/**
 * Default `null`, BUKAN `undefined` + throw. Hook tak boleh dipanggil
 * bersyarat, jadi `ProductDetail` memanggilnya juga di toko utama tempat
 * provider ini tak dipasang — `null` adalah jawaban yang benar di sana, dan
 * pemanggil menggerbangi diri sendiri lewat `catalogMode`.
 */
export const CatalogCartContext = createContext<CatalogCartApi | null>(null);

/** `null` di luar katalog reseller — pemanggil WAJIB menggerbangi. */
export function useCatalogCart(): CatalogCartApi | null {
  return useContext(CatalogCartContext);
}
